/**
 * Mobile navigation, powered by Alpine.js
 */
function mobileNav() {
    return {
        open: false,
        mobile: window.innerWidth < 768,
        cloneFooterNav() {
            if (this.mobile) {
                const oldNav = document.querySelector('.header--nav');
                const newNav = document.querySelector('.footer--nav');
                const navClone = newNav.cloneNode(true);
                navClone.classList.replace('footer--nav', 'header--nav');
                oldNav.replaceWith(navClone);
            }
        },
        resize() {
            return this.mobile = window.innerWidth < 768;
        },
    }
}

/*
 * Splide slider init
 */
document.addEventListener( 'DOMContentLoaded', function () {
    const elms= document.getElementsByClassName('splide');

    // Splide slider
    if (elms.length > 0) {
        for (let i = 0, len = elms.length; i < len; i++) {
            const splide = new Splide(elms[i], {
                type: 'fade',
                rewind: true,
                lazyLoad: 'nearby',
                interval: 5000,
                arrowPath: 'M8.701,4.139L22.061,17.499L8.699,30.861L10.819,32.981L26.301,17.499L10.821,2.019L8.701,4.139Z',
                autoplay: true,
                pauseOnHover: false,
            });

            // We only target the hero slider, which is index 0
            if (i === 0) {
                splide.on(['mounted', 'moved'], function (newIndex) {
                    _setSlideDependentInterfaceColors(elms, 0, newIndex);
                })
            }

            splide.mount();
        }
    } else {
        // Single slide

        if (window.innerWidth >= 768) {
            const siteHeader = document.querySelector('.site--header');
            const currentSlide = document.querySelector('.slide--single');
            const slideTextColor = currentSlide.style.color;

            const headerNav = siteHeader.querySelector('.header--nav');
            for (let item of headerNav.getElementsByTagName('a')) {
                item.style.color = slideTextColor;
            }

            const headerLogo = siteHeader.querySelector('.header--logo');
            for (let item of headerLogo.getElementsByTagName('path')) {
                item.style.fill = slideTextColor;
            }
        }
    }

    /*
     * InteractionObserver that helps to add and remove a class from the navigation (tablet and wider)
     */
    const header = document.querySelector('.site--header');
    let observer= new IntersectionObserver(entries => {
        if (entries[0].boundingClientRect.y <= 1) {
            header.classList.add('not-at-top');
        } else {
            header.classList.remove('not-at-top');
        }
    });

    observer.observe(document.querySelector("#pixel-to-watch"));
} );

function _setSlideDependentInterfaceColors(elms, i, newIndex) {
    const currentSlide = elms[i].querySelector('.splide__list').children.item(newIndex);
    const slideTextColor = currentSlide.querySelector('.slide--content').style.color;

    // Hamburger icon
    document.querySelector('.mobile-menu-closed').style.color = slideTextColor;

    // Splide arrows
    elms[i].querySelector('.splide__arrow--prev svg').style.fill = slideTextColor;
    elms[i].querySelector('.splide__arrow--next svg').style.fill = slideTextColor;

    // Navigation & logo
    if (window.innerWidth >= 768) {
        const headerNav = document.querySelector('.header--nav');
        for (let item of headerNav.getElementsByTagName('a')) {
            item.style.color = slideTextColor;
        }

        /*
        const headerLogo = document.querySelector('.header--logo');
        for (let item of headerLogo.getElementsByTagName('path')) {
            item.style.fill = slideTextColor;
        }
        */
    }
}
